import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { images } from '../data/links';
export function PurchasePopup() {
  const [index, setIndex] = useState(-1);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timer: number;
    const show = () => {
      setIndex(i => (i + 1) % buyers.length);
      setOpen(true);
      timer = window.setTimeout(hide, 5000);
    };
    const hide = () => {
      setOpen(false);
      timer = window.setTimeout(show, 9000);
    };
    timer = window.setTimeout(show, 6000);
    return () => window.clearTimeout(timer);
  }, [dismissed]);
  const buyer = index >= 0 ? buyers[index] : null;
  return <div aria-live="polite" className="pointer-events-none fixed bottom-[6.5rem] left-3 right-3 z-50 sm:bottom-5 sm:left-5 sm:right-auto sm:w-[22rem]" data-id="element-261" data-mp="1gz70gx1yv6zh">
      <AnimatePresence data-id="element-262" data-mp="164eiug87bsnf">
        {open && buyer && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_18px_40px_-12px_rgba(14,28,58,0.45)] ring-1 ring-line" data-id="element-263" data-mp="117o5i0ns7b5p">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-mist object-contain" data-id="element-264" data-mp="ia4pgd2wos9s" />
            <div className="min-w-0" data-id="element-265" data-mp="s67t5ndeoyyu">
              <p className="text-sm leading-snug text-ink" data-id="element-266" data-mp="s56hbgokg8g2">
                <strong data-id="element-267" data-mp="28kg4smwn1nvp">{buyer.name}</strong> from <strong data-id="element-268" data-mp="28jojc4wr96j5">{buyer.country}</strong> just purchased this digital book
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-ok" data-id="element-269" data-mp="23m67a5nfyb6x">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-270" data-mp="2ap32tfour0dt" />
                Verified purchase · {buyer.minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-ink/40 transition-colors duration-150 hover:bg-mist hover:text-ink" data-id="element-271" data-mp="2kmr5qswm3e72">
              <XIcon className="h-4 w-4" data-id="element-272" data-mp="1wx6b3cr3ishy" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}